import React from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite } from '@pixi/react';

const JackPotNumbersItemSymbol = observer(({ image, containerName }) => {
  return (
    <Container name={containerName}>
      <Sprite texture={image} scale={0.5} anchor={0.5} />
    </Container>
  );
});

export default JackPotNumbersItemSymbol;
